import React, { Component, lazy, Suspense } from "react";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import { connect } from "react-redux";
import { topNavOption } from "../../action/actions";
import loadingImg from "../../assets/loadingImg.png";

const FirstSection = lazy(() => import("./FirstSection/FirstSection"));
const SecondSection = lazy(() => import("./SecondSection/SecondSection"));
const ThirdSection = lazy(() => import("./ThirdSection/ThirdSection"));
const FourthSection = lazy(() => import("./FourthSection/FourthSection"));
const FifthSection = lazy(() => import("./FifthSection/FifthSection"));
const SixthSection = lazy(() => import("./SixthSection/SixthSection"));
const SeventhSection = lazy(() => import("./SeventhSection/SeventhSection"));

class LandingPage extends Component {
  componentDidMount = () => {
    window.scrollTo(0, 0);
    this.props.topNavOption("Home");
  };
  render() {
    return (
      <div>
        <Suspense
          fallback={
            <div className="loader-screen">
              <img className="App-logo" src={loadingImg} alt="logo" />
            </div>
          }
        >
          <Header />
          <FirstSection />
          <SecondSection />
          <ThirdSection />
          <FourthSection />
          <FifthSection />
          <SixthSection />
          <SeventhSection />
          <Footer />
        </Suspense>
      </div>
    );
  }
}

export default connect(null, { topNavOption })(LandingPage);
